import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createTextVNode as _$ct,
} from 'intact';
import {Sender, Button, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-paper'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'generating': this.get('generating'),
        'ev-messageSend': this.onMessageSend,
        'ev-stopGenerate': this.onStopGenerate,
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['uploadButton'] = function($super, scope) {
                        return (
                            _$cc(Button, {
                                'size': 'small',
                                'type': 'none',
                                'disabled': scope.disabled || scope.reachLimit,
                                'ev-click': scope.pickFiles,
                                'children': [
                                    _$cc(Icon, _$tmp0),
                                    _$ct('\n            上传文件\n        ')
                                ]
                            })
                        );
                    }),
                    (__$blocks['uploadButton'] = function($super, data) {
                        var block = $blocks['uploadButton'];
                        var callBlock = function() {
                            return _$blocks['uploadButton'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['sendButton'] = function($super, scope) {
                        return (
                            _$cc(Button, {
                                'type': 'primary',
                                'disabled': scope.generating ? scope.stopDisabled : scope.disabled,
                                'loading': scope.loading,
                                'ev-click': scope.generating ? scope.stopGenerate : scope.send,
                                'children': scope.generating ? '停止' : '发送'
                            })
                        );
                    }),
                    (__$blocks['sendButton'] = function($super, data) {
                        var block = $blocks['sendButton'];
                        var callBlock = function() {
                            return _$blocks['sendButton'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em),
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};